module.exports = __webpack_public_path__ + "static/media/image13.982cef93.png";